// import hooks
import { isNil } from 'ramda';
import { useGetEmployerCostSetting } from '../hooks/useGetEmployerCostSetting';

// import types
import {
  EmployerCostSettingFlagForm,
  EmployerCostSettingResponse,
  EmployerCostSettingsFormValues
} from '../EmployerCostSettings.types';

// import utils
import { convertFlagsArrayToObjects } from 'utils/misc';

// import components
import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';
import EmployerCostSettingsForm from './EmployerCostSettingsForm';
import { EmployerCostSettingsSkeleton } from './EmployerCostSettingsSkeleton';

interface Props {
  isCopy: boolean;
}

const convertRequestToFormData = (
  data: EmployerCostSettingResponse
): EmployerCostSettingsFormValues => {
  return {
    ...data,
    flags: convertFlagsArrayToObjects<EmployerCostSettingFlagForm>(data.flags)
  };
};

const EmployerCostSettings = ({
  handleClose,
  rowId,
  ...props
}: FormComponentProps & Props) => {
  const { isFetching, data } = useGetEmployerCostSetting(
    !isNil(rowId) ? Number(rowId) : rowId
  );

  return (
    <>
      {isFetching ? (
        <EmployerCostSettingsSkeleton />
      ) : (
        <EmployerCostSettingsForm
          data={data ? convertRequestToFormData(data) : undefined}
          handleClose={handleClose}
          isCopy={props.isCopy}
          isNew={isNil(rowId)}
        />
      )}
    </>
  );
};

export default EmployerCostSettings;
